import Service from "../../AuthService";

const CustomerSpecial = {
    getReportSpecialCustomer(page) {
        return Service.get("/special_customer?page="+page);
    },
    showSpecialCustomer(page,data){
        return Service.get("/show_special_customer?page=" +page+
            "&customer_id="+data.customer_id +
            "&start_date="+data.start_date +
            "&end_date="+data.end_date+
            "&product_type_id="+data.product_type_id
        );
    },
    searchSpecialCustomer(data){
        return Service.post("/search_special_customer",data)
    },
    printSpecialCustomer(data){
        return Service.get("/special-customer-pdf?" +
        "customer_id="+data.customer_id+
        "&start_date="+data.start_date+
        "&end_date="+data.end_date+
        "&product_type_id="+data.product_type_id);
    }
};

export default CustomerSpecial;
